import React, { ReactNode, useState } from "react";
import CustomModal from "shared/components/modal/CustomModal";
import { Tabela } from "shared/components/table/Tabela";
import { TableColumn } from "types/table/TableColumn";
import RenderRowsContatosRealizados from "./RenderRowsContatosRealizados";
import { useGestaoCobrancaCadastroContext } from "context/gestaoCobranca/GestaoCobrancaCadastroContext";
import { RequestContatosRealizados } from "types/request/RequestContatosRealizados";
import { useGetContatosRealizados } from "hooks/gestaoCobranca/useGetContatosRealizados";
import CustomButton from "shared/components/button/CustomButton";
import { usePostRelatorioGestaoCobranca } from "hooks/gestaoCobranca/usePostRelatorioGestaoCobranca";
import { toast } from "react-hot-toast";
import { FiltroGestaoCobrancaContatoDTO } from "types/dto/FiltroGestaoCobrancaContatoDTO";

interface ModalHistoricoContatosRealizadosProps {
  showModal: boolean;
  onCloseModal: () => void;
}

const ModalHistoricoContatosRealizados: React.FC<ModalHistoricoContatosRealizadosProps> = (
  props
) => {
  const [ordenarPorColuna, setOrdenarPorColuna] = useState<string>("");
  const [ordenacaoAscOuDesc, setOrdenacaoAscOuDesc] = useState<"ASC" | "DESC">();
  const [sortString, setSortString] = useState<string>("");
  const [paginaAtual, setPaginaAtual] = useState(1);
  const { unidadeId, condominioId } = useGestaoCobrancaCadastroContext();

  const params: RequestContatosRealizados = {
    size: 10,
    page: paginaAtual - 1,
    sort: sortString,
    unidadeId,
  };

  const { data: contatosRealizados, isFetching } = useGetContatosRealizados(
    params,
    props.showModal
  );

  const { mutate } = usePostRelatorioGestaoCobranca(unidadeId!, condominioId!);

  const handleEmitirRelatorio = () => {
    if (!unidadeId || !condominioId) {
      toast.error("Unidade ou condomínio não selecionados.");
      return;
    }

    const filtro: FiltroGestaoCobrancaContatoDTO = {
      unidadeId,
      condominioId,
    };

    mutate(filtro);
  };

  const createColumns = (): TableColumn[] => {
    return [
      {
        id: "dataContato,horarioContato",
        label: "Data",
        isOrdenavel: true,
      },
      {
        id: "anotacoes",
        label: "Anotações",
        isOrdenavel: false,
      },
      {
        id: "nomeUsuarioResponsavelPeloContato",
        label: "Responsável",
        isOrdenavel: true,
      },
      {
        id: "contatoRealizadoCom",
        label: "Contato realizado com",
        isOrdenavel: true,
      },
      {
        id: "canalComunicacao",
        label: "Canal de comunicação",
      },
      {
        id: "resultadoContato",
        label: "Resultado do contato",
      },
      {
        id: "motivoInadimplencia",
        label: "Motivo da inadimplência",
      },
    ];
  };

  const renderHistoricoDeContatosRealizados = (): ReactNode => {
    return (
      <div>
        <div className="text-end mb-3">
          <CustomButton
            className="rounded"
            variant="outline-primary"
            id="emitir-relatorio-contatos-realizados"
            label="Emitir relatório"
            size="lg"
            onClick={handleEmitirRelatorio} 
          />
        </div>
        <Tabela
          id="tabela-contatos-realizados"
          colunas={createColumns()}
          ordernarPorColuna={ordenarPorColuna}
          ordenacaoAscOuDesc={ordenacaoAscOuDesc}
          ordenarRegistrosFunction={(idColuna) => ordenarRegistros(idColuna)}
          onChangePageFunction={(paginaAtual: number) => setPaginaAtual(paginaAtual)}
          paginaAtual={paginaAtual}
          quantidadeDePaginas={contatosRealizados?.totalPages ?? 0}
          isLoading={isFetching}
          renderCheckBox={false}
          quantidadeDeRegistros={contatosRealizados?.totalElements ?? 0}
        >
          <RenderRowsContatosRealizados registros={contatosRealizados?.content ?? []} />
        </Tabela>
      </div>
    );
  };

  const ordenarRegistros = (idColuna: string) => {
    const novaOrdenacao =
      !ordenacaoAscOuDesc || ordenarPorColuna !== idColuna || ordenacaoAscOuDesc === "DESC"
        ? "ASC"
        : "DESC";
    setOrdenacaoAscOuDesc(novaOrdenacao);
    setOrdenarPorColuna(idColuna);
    setSortString(`${idColuna},${novaOrdenacao}`);
  };

  const closeModal = () => {
    setOrdenarPorColuna("");
    setOrdenacaoAscOuDesc(undefined);
    setSortString("");
    setPaginaAtual(1);
    props.onCloseModal();
  };

  return (
    <CustomModal
      titulo="Histórico de contato"
      onCloseModal={() => closeModal()}
      showModal={props.showModal}
      fecharModalAoClicarFora
      size="xl"
      tipoModal="MODAL_LATERAL"
      scrollable
    >
      {renderHistoricoDeContatosRealizados()}
    </CustomModal>
  );
};

export default ModalHistoricoContatosRealizados;